import type { ReactNode } from "react";

import { Popover, Portal } from "@/storybook-components";

type PopoverActionProps = {
  triggerIcon: ReactNode;
  content: ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
} & Record<string, unknown>;

const PopoverAction = ({
  triggerIcon,
  content,
  open,
  onOpenChange,
  ...rest
}: PopoverActionProps): JSX.Element => {
  const rootProps =
    open !== undefined
      ? {
          open,
          onOpenChange: (details: { open: boolean }) =>
            onOpenChange?.(details.open)
        }
      : {};

  return (
    <Popover.Root
      {...rootProps}
      positioning={{ placement: "bottom-end", gutter: 24 }}
    >
      {/*
        v3: `Popover.Trigger` renders its own <button> by default. When the
        provided `triggerIcon` is already an interactive element (IconButton /
        Button), we get invalid `<button><button>` nesting which the HTML
        parser silently corrects on the server, producing a client/server tree
        mismatch and the "Expected server HTML to contain a matching <button>
        in <button>" hydration error. `asChild` merges Ark's trigger props onto
        the provided element instead of wrapping it in another button.
      */}
      <Popover.Trigger asChild>{triggerIcon}</Popover.Trigger>
      <Portal>
        <Popover.Positioner>
          <Popover.Content {...rest}>
            <Popover.Body p={0}>{content}</Popover.Body>
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
};

export default PopoverAction;
